import { useEffect, useRef, useState } from "react";

const threshold = 120;

export const useChatScroll = (deps = []) => {
  const containerRef = useRef(null);
  const [isNearBottom, setIsNearBottom] = useState(true);

  const handleScroll = () => {
    const el = containerRef.current;
    if (!el) return;
    const remaining = el.scrollHeight - el.scrollTop - el.clientHeight;
    setIsNearBottom(remaining <= threshold);
  };

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    if (!isNearBottom) return;
    el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
  }, [isNearBottom, ...deps]);

  return {
    containerRef,
    handleScroll,
    isNearBottom,
  };
};

